import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "toast-backdrop",
    "aria-hidden": "true"
};
const _hoisted_2 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2 flex-shrink-0",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_3 = { class: "me-auto" };
const _hoisted_4 = {
    key: 2,
    class: "ms-2 opacity-75"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "toast-body" };
const _hoisted_7 = {
    key: 1,
    class: "d-flex align-items-center"
};
const _hoisted_8 = { class: "toast-body d-flex align-items-center gap-2 flex-wrap" };
const _hoisted_9 = {
    key: 0,
    class: "spinner-border spinner-border-sm flex-shrink-0",
    role: "status",
    "aria-hidden": "true"
};
const _hoisted_10 = {
    key: 2,
    class: "opacity-75"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
    key: 2,
    class: "toast-actions d-flex flex-wrap gap-2 px-3 pb-3 pt-1"
};
const _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_Transition, { name: "toast-backdrop" }, {
            default: _withCtx(() => [
                (_ctx.hasBlockingToast)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedToasts, (group, pos) => {
            return (_openBlock(), _createElementBlock("div", {
                key: pos,
                class: _normalizeClass(["toast-container position-fixed p-3", _ctx.positionClass(pos)]),
                style: { "z-index": "1100" }
            }, [
                _createVNode(_TransitionGroup, { name: "toast-slide" }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (toast) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: toast.id,
                                class: _normalizeClass(["toast show mb-2 border-0 position-relative overflow-hidden", _ctx.toastClass(toast)]),
                                role: "alert",
                                "aria-live": "assertive",
                                "aria-atomic": "true"
                            }, [
                                (toast.title)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["toast-header", _ctx.headerClass(toast)])
                                        }, [
                                            (toast.spinner)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                                                : (toast.icon)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 1,
                                                        class: _normalizeClass(`bi ${toast.icon} me-2 fs-6`)
                                                    }, null, 2))
                                                    : _createCommentVNode("", true),
                                            _createElementVNode("strong", _hoisted_3, _toDisplayString(toast.title), 1),
                                            (toast.showTimestamp)
                                                ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.timeAgo(toast.timestamp)), 1))
                                                : _createCommentVNode("", true),
                                            (toast.countdown > 0 && _ctx.countdownRemaining(toast) > 0)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 3,
                                                    class: _normalizeClass(["toast-countdown-badge ms-2", _ctx.countdownBadgeClass(toast)])
                                                }, _toDisplayString(_ctx.countdownRemaining(toast)), 3))
                                                : _createCommentVNode("", true),
                                            (toast.closable)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 4,
                                                    type: "button",
                                                    class: _normalizeClass(["btn-close ms-2", _ctx.closeBtnClass(toast)]),
                                                    "aria-label": "Schließen",
                                                    onClick: ($event) => (_ctx.removeToast(toast.id))
                                                }, null, 10, _hoisted_5))
                                                : _createCommentVNode("", true)
                                        ], 2),
                                        _createElementVNode("div", _hoisted_6, _toDisplayString(toast.message), 1)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            (toast.spinner)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                                                : (toast.icon)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 1,
                                                        class: _normalizeClass(`bi ${toast.icon} fs-5`)
                                                    }, null, 2))
                                                    : _createCommentVNode("", true),
                                            _createElementVNode("span", null, _toDisplayString(toast.message), 1),
                                            (toast.showTimestamp)
                                                ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.timeAgo(toast.timestamp)), 1))
                                                : _createCommentVNode("", true),
                                            (toast.countdown > 0 && _ctx.countdownRemaining(toast) > 0)
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 3,
                                                    class: _normalizeClass(["toast-countdown-badge", _ctx.countdownBadgeClass(toast)])
                                                }, _toDisplayString(_ctx.countdownRemaining(toast)), 3))
                                                : _createCommentVNode("", true)
                                        ]),
                                        (toast.closable)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: _normalizeClass(["btn-close me-2 m-auto flex-shrink-0", _ctx.closeBtnClass(toast)]),
                                                "aria-label": "Schließen",
                                                onClick: ($event) => (_ctx.removeToast(toast.id))
                                            }, null, 10, _hoisted_11))
                                            : _createCommentVNode("", true)
                                    ])),
                                (toast.actions.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toast.actions, (action, i) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: i,
                                                type: "button",
                                                class: _normalizeClass(["btn btn-sm", `btn-${action.variant ?? _ctx.defaultActionVariant(toast)}`]),
                                                onClick: ($event) => (action.onClick(() => _ctx.removeToast(toast.id)))
                                            }, [
                                                (action.icon)
                                                    ? (_openBlock(), _createElementBlock("i", {
                                                        key: 0,
                                                        class: _normalizeClass(`bi ${action.icon} me-1`)
                                                    }, null, 2))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(" " + _toDisplayString(action.label), 1)
                                            ], 10, _hoisted_13));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true),
                                (toast.countdown > 0 && _ctx.countdownRemaining(toast) > 0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 3,
                                        class: _normalizeClass(["toast-countdown-bar position-absolute bottom-0 start-0", _ctx.countdownBarClass(toast)]),
                                        style: _normalizeStyle({ width: _ctx.countdownPercent(toast) + '%' })
                                    }, null, 6))
                                    : _createCommentVNode("", true)
                            ], 2));
                        }), 128))
                    ]),
                    _: 2
                }, 1024)
            ], 2));
        }), 128))
    ], 64));
}
